import { useRef } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Browser, Phone, MOCKUPS, MOCK_URLS, SalonPhone } from "@/components/site/SiteMockups";
import { DEMOS } from "@/data/home";
import { SECTORS } from "@/data/sectors";

export const LIVE_DEMOS = { abbigliamento: "/demo/abbigliamento" };
const TINTS = { bar: "from-amber-100 to-orange-50", parrucchieri: "from-stone-300 to-stone-100", abbigliamento: "from-violet-100 to-fuchsia-50", botteghe: "from-lime-100 to-emerald-50", showroom: "from-slate-300 to-slate-100", artigiani: "from-orange-100 to-amber-50" };

const MiniPhone = ({ k }) => {
  if (k === "parrucchieri") return <SalonPhone />;
  const s = SECTORS.find((x) => x.key === k);
  return (
    <div className="flex h-full flex-col bg-white">
      <img src={s.img.replace("w=1200", "w=300")} alt="" loading="lazy" width="150" height="150" className="h-1/2 w-full object-cover" />
      <div className="space-y-1.5 p-2"><div className="h-2 w-3/4 rounded bg-slate-800" /><div className="h-1.5 w-full rounded bg-slate-200" /><div className="h-1.5 w-2/3 rounded bg-slate-200" /><div className="mt-2 h-4 rounded-full bg-slate-900" /></div>
    </div>
  );
};

export const DemoCard = ({ d }) => {
  const M = MOCKUPS[d.key];
  const s = SECTORS.find((x) => x.key === d.key);
  const live = LIVE_DEMOS[d.key];
  return (
    <Link to={live || `/soluzioni/${s.slug}`} data-testid={`demo-card-${d.key}`} className="group block w-[84%] sm:w-[48%] lg:w-[31.5%]">
      <div className={`relative rounded-3xl bg-gradient-to-br ${TINTS[d.key]} p-4 pb-8 pr-10 transition-[filter] group-hover:brightness-[1.03] sm:p-6 sm:pb-10 sm:pr-14`}>
        <div className="transition-transform duration-500 group-hover:-translate-y-1.5"><Browser url={MOCK_URLS[d.key]}><M /></Browser></div>
        <Phone className="absolute bottom-3 right-3 w-[24%] transition-transform duration-500 group-hover:-translate-y-2"><MiniPhone k={d.key} /></Phone>
      </div>
      <div className="mt-3 flex items-start justify-between gap-3 px-1">
        <div>
          <p className="font-display text-lg font-bold text-slate-900">{s.name}</p>
          <p className="text-sm text-slate-600">{d.style}</p>
        </div>
        {live
          ? <span className="chip shrink-0 border-emerald-200 bg-emerald-50 text-emerald-700">Demo navigabile</span>
          : <span className="chip shrink-0 border-slate-300 text-slate-600">Demo in arrivo</span>}
      </div>
    </Link>
  );
};

export default function PortfolioCarousel() {
  const row = useRef(null);
  const go = (dir) => row.current?.scrollBy({ left: dir * row.current.clientWidth * 0.8, behavior: "smooth" });
  return (
    <section id="portfolio" className="sec scroll-mt-20 bg-p-lavender">
      <div className="wrap">
        <div className="flex items-end justify-between gap-6">
          <div className="max-w-xl">
            <h2 className="h-section">Un sito diverso per <span className="hl-light">ogni attività.</span></h2>
            <p className="mt-2 text-slate-600">Sei stili, sei settori. Scorri e trova il tuo.</p>
          </div>
          <div className="hidden gap-2 sm:flex">
            <button type="button" onClick={() => go(-1)} data-testid="portfolio-prev" aria-label="Precedente" className="grid h-11 w-11 place-items-center rounded-full border border-slate-300 transition-colors hover:border-slate-900 hover:bg-slate-900 hover:text-white"><ArrowLeft className="h-4 w-4" /></button>
            <button type="button" onClick={() => go(1)} data-testid="portfolio-next" aria-label="Successivo" className="grid h-11 w-11 place-items-center rounded-full border border-slate-300 transition-colors hover:border-slate-900 hover:bg-slate-900 hover:text-white"><ArrowRight className="h-4 w-4" /></button>
          </div>
        </div>
        <div ref={row} data-testid="portfolio-carousel" className="snap-row mt-8 !gap-5">
          {[...DEMOS].sort((a, b) => (LIVE_DEMOS[b.key] ? 1 : 0) - (LIVE_DEMOS[a.key] ? 1 : 0)).map((d) => <DemoCard key={d.key} d={d} />)}
        </div>
      </div>
    </section>
  );
}
